import axios from 'axios';
import {
    PARTNERSHIP_API,
    API_HEADER
} from '../../../constants/API'
import {
    DELETE_PARTNERSHIP_PRODUCT_LOADING
} from '../types';
import { message } from 'antd';

export default (id, data) => {
    return async (dispatch, getState) => {
        try {
            dispatch({
                type: DELETE_PARTNERSHIP_PRODUCT_LOADING,
                deletingPartnershipProduct: true
            })
            const { token } = getState().UserReducer;
            const postData = { ...data }
            await axios.delete(`${PARTNERSHIP_API}/products/${id}`, { data: postData, ...API_HEADER(token) })
            dispatch({
                type: DELETE_PARTNERSHIP_PRODUCT_LOADING,
                deletingPartnershipProduct: false
            })
        } catch(e) {
            if (e && e.response && e.response.data) {
                message.error(String(e.response.data))
            }            
            dispatch({
                type: DELETE_PARTNERSHIP_PRODUCT_LOADING,
                deletingPartnershipProduct: false
            })

        }
    }
}